if (!customElements.get('cart-terms-check')) {
  class CartTermsCheck extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.checkbox = this.querySelector('.cart__terms-checkbox');
      this.checkoutButton = this.querySelector('.cart__checkout-button');
      this.checkoutButtonWrapper = this.querySelector('.cart__checkout-button-wrapper');
      this.checkoutButtonValidation = this.querySelector('.cart__checkout-button-validation');
      

      if (!this.checkbox || !this.checkoutButton) return;
      this.attachEvents();
    }

    attachEvents() {
      this.checkoutButton.addEventListener('click', (event) => {
        if (!this.checkbox.checked) {
          event.preventDefault();
          event.stopImmediatePropagation(); 
          this.checkbox.setCustomValidity(window.cartStrings.termsCheckboxNotify);
          this.checkbox.reportValidity();
          return false;
        } else {
          this.checkbox.setCustomValidity('');
        }
      });

      this.checkoutButtonWrapper.addEventListener('click', (event) => {
        const self = this;

        if (!this.checkbox.checked) {
          this.classList.add('validation--error')
          setTimeout(function() {
            self.classList.remove('validation--error')
          }, 500);
          this.checkoutButtonValidation.classList.remove('hide')
        } else {
          this.checkoutButtonValidation.classList.add('hide')
          // this.classList.remove('validation--error')
        }
      });

      this.checkbox.addEventListener('change', () => {
        if (this.checkbox.checked) {
          this.checkbox.setCustomValidity('');
          this.checkoutButtonValidation.classList.add('hide')
        }

        this.checkoutButton.disabled = !this.checkbox.checked;
      });
    }
  }

  customElements.define('cart-terms-check', CartTermsCheck);
}
